import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Typography, Box } from '@mui/material';

import { mfaColors } from '../styles';

export const SecurityRequirementHeader = ({ headline, isPatient }) => (
  <Box sx={{ textAlign: 'center' }}>
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: 2,
        background: `linear-gradient(135deg, ${mfaColors.primary}15, ${mfaColors.primary}25)`,
        border: `2px solid ${mfaColors.primary}30`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mx: 'auto',
        mb: 2.5,
      }}
    >
      <LockOutlinedIcon sx={{ color: mfaColors.primary, fontSize: 28 }} />
    </Box>

    <Typography variant="h5" sx={{ fontWeight: 700, color: mfaColors.text, mb: 1.5 }}>
      {headline}
    </Typography>

    <Typography variant="body2" sx={{ color: mfaColors.textMuted, lineHeight: 1.6, mb: 1 }}>
      {isPatient
        ? 'To keep your medical information safe, we now require two-factor authentication.'
        : 'Your account requires two-factor authentication using an authenticator app to ensure the highest level of security.'}
    </Typography>

    {isPatient && (
      <Typography variant="body2" sx={{ color: mfaColors.textMuted, lineHeight: 1.6 }}>
        We recommend using an authenticator app for the best security, though SMS verification is also available.
      </Typography>
    )}
  </Box>
);
